
import { Component, Prop, Vue } from 'vue-property-decorator'

export interface Tab {
  id: string
  title: string
  subtitle?: string
  disabled?: boolean
  classes?: string
}

@Component({ name: 'Tabs' })
export default class extends Vue {
  @Prop({ required: true })
  items: Tab[]

  @Prop({ default: null })
  selected: string | null

  selectTab(id) {
    this.$emit('update:selected', id)
  }

  classes(item: Tab): any {
    return {
      [item.classes as string]: Boolean(item.classes),
      selected: this.selected === item.id,
    }
  }
}
